/* eslint-disable react/no-unescaped-entities */
import PublicPageLayout, { Section } from "@/components/PublicPageLayout";

export default function Terms() {
  return (
    <PublicPageLayout
      eyebrow="Legal"
      title="Terms & conditions"
      intro="These terms govern your use of The AI Took My Job. Please read them carefully. Last updated February 2026."
      testid="terms-page"
    >
      <Section title="1. Acceptance" testid="terms-acceptance">
        <p>
          By creating an account or using any part of the platform you agree to these terms. If
          you don't agree, please don't use the service.
        </p>
      </Section>

      <Section title="2. Who can use the service" testid="terms-eligibility">
        <p>
          You must be at least 18 years old and a resident of Australia to create an account. One
          account per person.
        </p>
      </Section>

      <Section title="3. Subscription, billing & minimum term" testid="terms-billing">
        <ul className="list-disc pl-6 space-y-2">
          <li>
            Career Transition Membership: AUD $50 per month + 10% GST = AUD
            $55 per month including GST.
          </li>
          <li>
            Minimum commitment: three (3) months from your first paid billing
            date ($165 inc. GST total). After the minimum term, the
            subscription continues month-to-month until cancelled.
          </li>
          <li>
            My Archive plan: AUD $10/month + GST, billed once a year as a
            single $132 inc. GST charge ($120 + $12 GST). Renews annually;
            access continues until the end of the prepaid 12 months when
            cancelled.
          </li>
          <li>Payment is processed by Stripe. By subscribing you authorise recurring charges.</li>
          <li>Failed payments may result in suspension of the report and job-matching features.</li>
        </ul>
      </Section>

      <Section title="4. Cancellation & refunds" testid="terms-cancellation">
        <p>
          You can cancel any time from Account → Subscription. After your three-month minimum,
          your subscription ends at the end of the current billing cycle. Within the first 14 days
          of your first subscription we will consider goodwill refunds on a case-by-case basis.
        </p>
      </Section>

      <Section title="5. Acceptable use" testid="terms-conduct">
        <ul className="list-disc pl-6 space-y-2">
          <li>Don't share your account or resell access.</li>
          <li>Don't submit false or misleading information in your assessment.</li>
          <li>Don't attempt to scrape, reverse-engineer or overload our systems.</li>
          <li>Don't use the platform to harass, defame or break the law.</li>
        </ul>
        <p>We may suspend or terminate accounts that breach these rules.</p>
      </Section>

      <Section title="6. Your content" testid="terms-content">
        <p>
          You own everything you write in your assessment. You grant us a limited licence to
          process that content (including via AI providers) only to deliver the service.
        </p>
      </Section>

      <Section title="7. AI-generated guidance" testid="terms-ai">
        <p>
          Career pathways, government support indications and job matches are AI-generated and
          informational only. They are not legal, financial, medical or migration advice. See the
          Disclaimer page for full details.
        </p>
      </Section>

      <Section title="8. Service availability" testid="terms-availability">
        <p>
          We aim for high uptime but do not guarantee uninterrupted service. Planned maintenance
          will be announced where reasonable.
        </p>
      </Section>

      <Section title="9. Liability" testid="terms-liability">
        <p>
          To the maximum extent permitted by Australian law, our total liability for any claim is
          limited to the amount you paid us in the 12 months preceding the claim. Nothing in these
          terms limits rights you have under the Australian Consumer Law that cannot be excluded.
        </p>
      </Section>

      <Section title="10. Governing law" testid="terms-law">
        <p>
          These terms are governed by the laws of New South Wales, Australia. Disputes will be
          resolved in the courts of New South Wales unless required otherwise.
        </p>
      </Section>

      <Section title="11. Changes to these terms" testid="terms-changes">
        <p>
          We may update these terms. Material changes will be notified at least 14 days in
          advance. Continued use after the change date constitutes acceptance.
        </p>
      </Section>
    </PublicPageLayout>
  );
}
